import { useMemo, useState } from "react";

import useDebounce from "./useDebounce";

export const useDebouncedValue = (
  timeout = 300,
): {
  value: string;
  setValue: React.Dispatch<React.SetStateAction<string>>;
  debouncedValue: string;
} => {
  const [value, setValue] = useState<string | undefined>("");
  const debouncedValue = useDebounce(value, timeout);

  const resultOptions = useMemo(() => {
    return {
      value,
      setValue,
      debouncedValue,
    };
  }, [value, timeout, debouncedValue]);

  return resultOptions;
};
